import React from 'react';
import HorseCard from '../components/HorseCard';

// Dummy data representing the horses in the cavalry
const dummyHorses = [
  {
    id: 1,
    name: 'Dakota',
    description: 'L\'incarnation du calme et de la douceur, idéal pour les cavaliers en quête d\'un compagnon fiable et doux. ',
    breed: 'ONC',
    photoUrl: '/photos/dakota.jpg', // Placeholder image path
  },
  {
    id: 2,
    name: 'Lancelot',
    description: 'Un jeune comtois calme et suiveur, parfait pour les débutants et les cavaliers expérimentés.',
    breed: 'Comtois',
    photoUrl: '/photos/lancelot.jpg',
  },
  {
    id: 3,
    name: 'Jelika',
    description: 'Grande ponette pleine d\'énergie, idéale pour les jeunes et les cavaliers en quête d\'un compagnon dynamique et joueur.',
    breed: 'ONC poney',
    photoUrl: '/photos/jelika.jpg',
  },
];

const CavalryPage: React.FC = () => {
  return (
    <div className="cavalry-page-container">
      <header className="page-header">
        <h1>Notre cavalerie</h1>
        <p>Découvrez nos chevaux</p>
      </header>

      <section className="container events-list">
        {dummyHorses.map(horse => (
          <HorseCard key={horse.id} horse={horse} />
        ))}
      </section>
    </div>
  );
};

export default CavalryPage;